import { useContext } from "react";
import Markdown from "react-markdown";
import { LocaleContext } from "../../app";
import { Button } from "../button";

const dialogId = (pageKey) => `dialog-${pageKey}`;

export function InfoDialogButton({ pageKey }) {
  const { translate } = useContext(LocaleContext);
  return (
    <Button
      variation="outlined"
      className="dialog-trigger"
      iconInfo
      command="show-modal"
      commandfor={dialogId(pageKey)}
    >
      {translate("dialog.open")}
    </Button>
  );
}

export function InfoDialog({ pageKey }) {
  const { translate } = useContext(LocaleContext);
  const body = translate(`recommendations.${pageKey}.dialog_body`);
  return (
    <dialog className="dialog" id={dialogId(pageKey)}>
      <header className="dialog__header">
        <Button
          variation="clear"
          className="dialog__close"
          iconClose
          srText
          command="close"
          commandfor={dialogId(pageKey)}
        >
          {translate("dialog.close")}
        </Button>
        <h2 className="dialog__title">{translate("dialog.title")}</h2>
      </header>
      <div className="dialog__body">
        <Markdown>{body}</Markdown>
      </div>
    </dialog>
  );
}
